import { DialogTrigger } from 'react-aria-components';

import { Button, Popup, Stack, Text } from '@ekhodealer/ekho-common/rev';

interface DeleteDiscountDialogProps {
	discountName: string;
	isOpen: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
	isDeleting: boolean;
}

export const DeleteDiscountDialog = ({
	discountName,
	isOpen,
	onOpenChange,
	onConfirm,
	isDeleting,
}: DeleteDiscountDialogProps) => {
	return (
		<DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
			<Popup title='Delete discount?'>
				<Stack padding='0' itemsSpacing='24'>
					<Text size='body' color='secondary'>
						Are you sure you want to delete &ldquo;{discountName}&rdquo;? This action
						cannot be undone.
					</Text>
					<>
						<style>
							{`
							.delete-discount-destructive-button button[data-rev-variant="filled"] {
								background-color: #ef4444 !important;
								color: white !important;
							}
							.delete-discount-destructive-button button[data-rev-variant="filled"]:hover:not(:disabled) {
								background-color: #dc2626 !important;
							}
							`}
						</style>
						<div
							style={{
								display: 'flex',
								justifyContent: 'flex-end',
								gap: '12px',
								paddingTop: '8px',
							}}>
							<Button
								variant='secondary'
								size='medium'
								onPress={() => onOpenChange(false)}
								isDisabled={isDeleting}>
								Cancel
							</Button>
							<div className='delete-discount-destructive-button'>
								<Button
									variant='filled'
									size='medium'
									onPress={onConfirm}
									isLoading={isDeleting}>
									Delete
								</Button>
							</div>
						</div>
					</>
				</Stack>
			</Popup>
		</DialogTrigger>
	);
};
